import script from "./TriggerSettings.vue?vue&type=script&lang=js"
export * from "./TriggerSettings.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__